// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qrgen{display:table;margin:15px auto}", "",{"version":3,"sources":["webpack://./app/components/qr-code-generator/qr-code-generator.scss"],"names":[],"mappings":"AAAA,OAAO,aAAa,CAAC,gBAAgB","sourcesContent":[".qrgen{display:table;margin:15px auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
